export default __webpack_public_path__ + "static/media/storymap.304a26e0.svg";